module.exports = __webpack_public_path__ + "media/images/payments/sepa-98f3e61d65b7393a797437b0380aa492.svg";